import { inject, Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import { type Schema } from '../../../../amplify/data/resource';
import { getCurrentUser } from '@aws-amplify/auth';
import { FileService } from './file-s3.service';

@Injectable({ providedIn: 'root' })
export class CommentService {
  private _client?: ReturnType<typeof generateClient<Schema>>;

  private get client() {
    if (!this._client) {
      this._client = generateClient<Schema>();
    }
    return this._client;
  }

  private fileService = inject(FileService);

  async createComment(taskId: string, content: string, imagePaths?: string[]) {
    const user = await getCurrentUser();
    const { data, errors } = await this.client.models.Comment.create({
      content,
      taskId,
      createdAt: new Date().toISOString(),
      createdBy: user.userId,
      imagePaths: imagePaths || [],
    });
    if (errors || !data) throw new Error(errors ? errors[0].message : "No data returned");
    return data;
  }

  async listComments(taskId: string) {
    const { data, errors } = await this.client.models.Comment.listCommentsByTaskId({ taskId });
    if (errors || !data) return [];
    return data;
  }

  async uploadCommentImages(files: File[], commentId: string) {
    return this.fileService.uploadFiles(files, 'commentImage', commentId);
  }

  async getCommentImageUrl(path: string | null | undefined) {
    return this.fileService.getFileUrl(path);
  }
}
